import Icon from '../components/Icon.vue'

Icon.register({"copy":{"width":448,"height":512,"paths":[{"d":"M320 448V488C320 501.3 309.3 512 296 512H24C10.7 512 0 501.3 0 488V120C0 106.7 10.7 96 24 96H96V392C96 422.9 121.1 448 152 448H320zM320 104V0H152C138.7 0 128 10.7 128 24V392C128 405.3 138.7 416 152 416H424C437.3 416 448 405.3 448 392V128H344C330.8 128 320 117.2 320 104zM441 73L375 7A24-24 0 0 1 358.1 0H352V96H448V89.9A24-24 0 0 1 441 73z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/copy.js
// module id = IF6D
// module chunks = 0